// removed by extract-text-webpack-plugin
module.exports = {"appMenu":"src-components-menu-__menu-module___appMenu","innerWrapper":"src-components-menu-__menu-module___innerWrapper","centerMenu":"src-components-menu-__menu-module___centerMenu","menuItem":"src-components-menu-__menu-module___menuItem","active":"src-components-menu-__menu-module___active","appLogo":"src-components-menu-__menu-module___appLogo"};


//////////////////
// WEBPACK FOOTER
// ./src/components/menu/menu.module.css
// module id = 418
// module chunks = 52